import { HttpParams } from "@angular/common/http";

export class UrlParamsUtils {

  private urlParamsType: UrlParamsType;

  constructor(urlParamsType: UrlParamsType) {
    this.urlParamsType = urlParamsType;
  }

  public buildUrlParams(paramsObject: any): HttpParams {
    return this.urlParamsType.buildParams(paramsObject);
  }
}

export interface UrlParamsType {
  buildParams(paramsObject: any): HttpParams;
}

export class KebabParams implements UrlParamsType {
  public buildParams(paramsObject: any): HttpParams {
    let httpParams = new HttpParams();
    const REGEX = /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g;

    Object.keys(paramsObject).forEach(key => {
      const paramKey = key
        .match(REGEX)
        ?.map((x) => x.toLowerCase())
        .join('-');

      const paramValue = paramsObject[key];

      if (paramValue != '' && paramValue != null) {
        httpParams = httpParams.append(paramKey, paramValue);
      }

    });

    return httpParams;
  }
}

export class CamelCaseParams implements UrlParamsType {
  public buildParams(paramsObject: any): HttpParams {
    let httpParams = new HttpParams();

    Object.keys(paramsObject).forEach(key => {
      const paramValue = paramsObject[key];

      if (paramValue != '' && paramValue != null) {
        httpParams = httpParams.append(key, paramValue);
      }

    });

    return httpParams;
  }
}

